import {borderColorLightest} from '../../styles';
import {DateRange} from '../DateRange';
import {CalendarMod} from './CalendarMod';
import {formatDate} from '../../dates/dates';
import {selectBackgroundColor} from './color';

export function buildBackgroundImage(
  dateRange: DateRange,
  cellWidth: number,
  mod?: CalendarMod,
): string {
  return createImage(dateRange, cellWidth, mod);
}

function fillRect(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  w: number,
  h: number,
  color: string,
) {
  ctx.fillStyle = color;
  ctx.fillRect(x, y, w, h);
}

function createImage(
  dateRange: DateRange,
  cellWidth: number,
  mod?: CalendarMod,
): string {
  const canvas = document.createElement('canvas');
  canvas.width = cellWidth * dateRange.len;
  canvas.height = 1;
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    return '';
  }

  const todayText = formatDate(new Date());

  dateRange.eachDate((date, index) => {
    const color = selectBackgroundColor(date, todayText, mod);
    fillRect(ctx, index * cellWidth, 0, cellWidth - 1, 1, color);
    fillRect(ctx, (index + 1) * cellWidth - 1, 0, 1, 1, borderColorLightest);
  });

  return canvas.toDataURL();
}
